import { getAuthMethod } from "../services/HttpServices";
import { leadCustomFieldDefinitions as leadCustomFieldDefinitionsAPI } from "../constant/Constant";

export const LEAD_CUSTOM_FIELDS_MODULE = "Custom Fields";
export const LEAD_CUSTOM_FIELD_SCOPE = "lead";

const getDefaultValueByType = (field) => {
  if (!field) return "";
  if (field?.defaultValue !== undefined && field?.defaultValue !== null) {
    return field.defaultValue;
  }
  return "";
};

export const isLeadManagedCustomField = (field) =>
  field?.fieldScope === LEAD_CUSTOM_FIELD_SCOPE || (field?.definition && field?.definition?.id);

export const getLeadCustomFieldIsActive = (field) => {
  if (field?.isActive !== undefined) return field.isActive;
  if (field?.active !== undefined) return field.active;
  return true;
};

export const getLeadCustomFieldsState = (
  definitions = [],
  existingFields = [],
) => {
  const availableDefinitions = Array.isArray(definitions) ? definitions : [];
  const existingCustomFields = Array.isArray(existingFields) ? existingFields : [];

  const webToLeadCustomFields = existingCustomFields.filter(
    (field) => !isLeadManagedCustomField(field),
  );

  const visibleDefinitions = availableDefinitions.filter((definition) => {
    if (getLeadCustomFieldIsActive(definition) === false) return false;
    return true;
  });

  const leadCustomFields = visibleDefinitions.map((definition) => {
    const matchedField = existingCustomFields.find(
      (field) =>
        isLeadManagedCustomField(field) &&
        (field?.id === definition?.id || field?.definition?.id === definition?.id || field?.fieldName?.toLowerCase() === definition?.fieldName?.toLowerCase()),
    );

    return {
      ...definition,
      fieldCategory: "custom",
      fieldScope: LEAD_CUSTOM_FIELD_SCOPE,
      isSelected: true,
      valueId: matchedField?.id,
      fieldValue:
        matchedField?.fieldValue !== undefined
          ? matchedField.fieldValue
          : getDefaultValueByType(definition),
    };
  });

  return {
    leadCustomFields,
    webToLeadCustomFields,
    allCustomFields: [...webToLeadCustomFields, ...leadCustomFields],
  };
};

export const isFieldMandatory = (fieldName, customFieldDefinitions = []) => {
  if (fieldName === "firstname" || fieldName === "lastname") return true;

  if (String(fieldName || "").startsWith("customField__")) {
    const customFieldName = fieldName.replace("customField__", "");
    const fieldDef = customFieldDefinitions.find(
      (f) => f.fieldName === customFieldName,
    );
    return fieldDef?.isMandatory || fieldDef?.isOptional === false;
  }

  if (String(fieldName || "").startsWith("custom_")) {
    const fieldId = parseInt(fieldName.replace("custom_", ""), 10);
    const fieldDef = customFieldDefinitions.find((f) => f.id === fieldId);
    return fieldDef?.isMandatory || fieldDef?.isOptional === false;
  }

  return false;
};

export const getActiveLeadCustomFieldDefinitionsAPI = async () => {
  try {
    const res = await getAuthMethod(leadCustomFieldDefinitionsAPI);
    const data = res?.data;
    const content = Array.isArray(data) ? data : (Array.isArray(data?.content) ? data.content : []);
    return content.filter(getLeadCustomFieldIsActive);
  } catch (error) {
    console.error("Error fetching lead custom field definitions:", error);
    return [];
  }
};
